import React from 'react'
import { FormProvider } from 'react-hook-form'
import { ModalBase, IModalBaseProps, MODAL_TYPES } from 'transfix-ui/components/Modals'
import { IConnectionConfigEnvironment, IFtpConnectionTypes } from 'types/graphqlTypes'
import { InboundFileRouterConfigModalForm } from '../../forms/InboundFileRouterConfigModalForm'
import { useInboundFileRouterConfigModalForm } from '../../hooks/useInboundFileRouterConfigModalForm'
import { TInboundFileRouterConfigModalSchema } from '../../schema/InboundFileRouterConfigModalSchema'

interface IInboundFileRouterConfigModalProps extends Omit<IModalBaseProps, 'modalType'> {
  defaultValues?: {}
  onSubmit: (options: TInboundFileRouterConfigModalSchema) => void
}

const getDefaultValues = () => {
  return {
    connectionType: IFtpConnectionTypes.SFTP_WITH_PRIVATE_KEY,
    disabled: true,
    environment: IConnectionConfigEnvironment.staging,
    port: 0,
    username: '',
    secretKey: '',
    pathPrefix: '',
    host: '',
    tmsName: '',
    shipperCodeJson: JSON.stringify({
      route_by_known_segment: {
        '204': [
          {
            segment: '',
            element_position: 0,
            qualifier: '',
            qualifier_position: 0,
          },
        ],
      },
    }),
  }
}

export const InboundFileRouterConfigModal = ({
  defaultValues,
  onClose,
  onSubmit,
  open = false,
  ...props
}: IInboundFileRouterConfigModalProps) => {
  const methods = useInboundFileRouterConfigModalForm({
    defaultValues: defaultValues ?? getDefaultValues(),
  })

  const { handleSubmit } = methods || {}

  const actions: IModalBaseProps['actions'] = [
    {
      label: 'Cancel',
      action: () => {
        onClose()
      },
      type: 'dismiss',
      dataTest: 'cancel-button',
    },
    {
      label: 'Save',
      action: handleSubmit((data: TInboundFileRouterConfigModalSchema) => {
        onSubmit(data)
        onClose()
      }),
      type: 'confirm',
      dataTest: 'confirm-button',
    },
  ]

  return (
    <ModalBase
      dataTest='InboundFileRouterConfigModal'
      modalType={MODAL_TYPES.form}
      size={4}
      open={open}
      actions={actions}
      onClose={onClose}
      {...props}>
      <FormProvider {...methods}>
        <InboundFileRouterConfigModalForm />
      </FormProvider>
    </ModalBase>
  )
}
